import { DraggableProvided } from "@hello-pangea/dnd";
import React from "react";

interface DraggableItemProps {
  item: {
    title: string;
    type?: string;
  };
  provided: DraggableProvided;
  type: ReorderType;
}

export enum ReorderType {
  TABS = "Tabs",
  GROUPS = "Groups",
  COMPONENTS = "Components",
}

const DraggableItem = ({ item, provided, type }: DraggableItemProps) => {
  const renderContent = () => {
    switch (type) {
      case ReorderType.TABS:
        return <div className="p-text-bold">{item.title}</div>;

      case ReorderType.COMPONENTS:
        return (
          <>
            <div className="flex flex-row gap-2">
              <div className="w-4rem font-bold">Title:</div>
              <div>{item.title || "Untitled Component"}</div>
            </div>
            <div className="flex flex-row gap-2">
              <div className="w-4rem font-bold">Type:</div>
              <div>{item.type || "Unknown Type"}</div>
            </div>
          </>
        );

      case ReorderType.GROUPS:
        return <div className="p-text-bold">{item.title || "Untitled Group"}</div>;

      default:
        return null;
    }
  };

  return (
    <div
      ref={provided.innerRef}
      {...provided.draggableProps}
      {...provided.dragHandleProps}
      className="flex flex-column border-round p-3 p-shadow-2 p-mb-3"
      style={{ ...provided.draggableProps.style, cursor: "grab" }}
    >
      {renderContent()}
    </div>
  );
};

export default DraggableItem;
